const featuresData = [
  { icon: 'ri-shield-check-line', title: '多线路保障', desc: '51、91、17等多个数字版专属线路，单线故障自动切换备用入口，确保访问稳定不中断。' },
  { icon: 'ri-flashlight-line', title: '极速更新', desc: '热点事件发生15分钟内同步上线，7x24小时不间断追踪全网爆料动态。' },
  { icon: 'ri-eye-off-line', title: '隐私安全', desc: '全站HTTPS加密传输，不记录用户浏览行为，访问记录即时清除不留痕。' },
  { icon: 'ri-stack-line', title: '海量内容', desc: '收录黑料吃瓜52、92、18等版本完整数据库，覆盖娱乐、综艺、网红全领域。' },
  { icon: 'ri-smartphone-line', title: '全平台适配', desc: '桌面端与移动端体验一致，无需下载APP即可通过浏览器直接访问所有功能。' },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">平台优势</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">为什么数百万用户选择黑料吃瓜作为第一手爆料来源</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/60 hover:border-accent-200 transition-colors group cursor-default"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-white transition-colors">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}